'use strict'
import api from '@/api/api'
import notify from "@/utils/notify"

export default {
  async getTransactions(params = {}) {
    const query = new URLSearchParams()
    if (params.page) query.set('page', params.page)
    if (params.per_page) query.set('per_page', params.per_page)
    if (params.search) query.set('search', params.search)
    if (params.store_id) query.set('store_id', params.store_id)

    const data = {
      method: 'get',
      url: `transactions${query.toString() ? `?${query.toString()}` : ''}`,
    }

    const response = await api.api(data)
    if (response.status === 200) {
      return response.data
    }
  },
  async createTransaction(json) {
    const data = {
      method: 'post',
      url: 'transaction',
      body: json,
    }

    const response = await api.api(data)
    if (response.status === 201) {
      notify.alert.success('Transaction created successfully')
      return true;
    }
  },
}
